export const ticketPaginationKeys = (boardId: string, viewId: string) => [
  'data',
  ['tickets', boardId, viewId],
];
